import React from 'react';
import { FormError, HelpText } from '@Forms/fields.jsx';

const FieldWrapper = ({
  children,
  className,
  error,
  helpText,
  label,
  name,
  ...props
}) => {
  // generic field wrapper
  //
  // actual field is passed as children
  return (
    <div
      className={
        `sb-form-item-formgroup ` +
        (error ? 'sb-form-item-error' : '') +
        ' ' +
        (className ? className : '')
      }
    >
      {label && <label htmlFor={name}>{label}</label>}
      <div className="sb-form-item-content">
        {children}
        {helpText && <HelpText message={helpText} />}
        {error && <FormError message={error.message} />}
      </div>
    </div>
  );
};

export default FieldWrapper;
